import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`

export const Item = styled.div`
    flex: 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    cursor: pointer;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    transition: transform .2s;

    :hover{
        opacity: 0.8;
        transform: scale(1.05);
    }
`

export const Title = styled.h3`
`

export const MoneyWrapper = styled.div`
    margin: 10px 0px;
    display: flex;
    align-items: center;
`

export const Money = styled.span`
    font-size: var(--fontL);
    font-weight: 600;
`

export const Rate = styled.div`
    display: flex;
    align-items: center;
    margin-left: 20px;
`

export const Sub = styled.span`
    font-size: var(--fontXS);
`